import { createUseStyles } from 'react-jss';

const useStylesGridItem = createUseStyles((theme) => {
  const { breakpoints, grid } = theme;

  const width = (size) => {
    return size ? `${100 * (size / grid.columns)}%` : 0;
  };

  const gridGutter = (size) => (size ? grid.gutter[size] / 2 : 0);

  return {
    wrenchGridItem: {
      flexGrow: '1',
      flexBasis: '0',
      maxWidth: '100%',

      [`@media (min-width: ${breakpoints.xs})`]: {
        flex: ({ xs }) => xs && `0 0 ${width(xs)}`,
        maxWidth: ({ xs }) => xs && width(xs),
        order: ({ xsOrder }) => xsOrder,
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('xs'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('xs'),
      },

      [`@media (min-width: ${breakpoints.sm})`]: {
        flex: ({ sm }) => sm && `0 0 ${width(sm)}`,
        maxWidth: ({ sm }) => sm && width(sm),
        order: ({ smOrder }) => smOrder,
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('sm'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('sm'),
      },

      [`@media (min-width: ${breakpoints.md})`]: {
        flex: ({ md }) => md && `0 0 ${width(md)}`,
        maxWidth: ({ md }) => md && width(md),
        order: ({ mdOrder }) => mdOrder,
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('md'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('md'),
      },

      [`@media (min-width: ${breakpoints.lg})`]: {
        flex: ({ lg }) => lg && `0 0 ${width(lg)}`,
        maxWidth: ({ lg }) => lg && width(lg),
        order: ({ lgOrder }) => lgOrder,
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('lg'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('lg'),
      },

      [`@media (min-width: ${breakpoints.xl})`]: {
        flex: ({ xl }) => xl && `0 0 ${width(xl)}`,
        maxWidth: ({ xl }) => xl && width(xl),
        order: ({ xlOrder }) => xlOrder,
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('xl'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('xl'),
      },
    },
  };
});

export default useStylesGridItem;
